import { Injectable, defineInjectable } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class BrowserGlobalsService {
    constructor() {
    }
    /**
     * @return {?}
     */
    windowRef() {
        return window;
    }
    /**
     * @return {?}
     */
    documentRef() {
        return document;
    }
}
BrowserGlobalsService.ɵfac = function BrowserGlobalsService_Factory(t) { return new (t || BrowserGlobalsService)(); };
BrowserGlobalsService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BrowserGlobalsService, factory: BrowserGlobalsService.ɵfac, providedIn: 'root' });
/** @nocollapse */
BrowserGlobalsService.ctorParameters = () => [];
/** @nocollapse */ BrowserGlobalsService.ngInjectableDef = defineInjectable({ factory: function BrowserGlobalsService_Factory() { return new BrowserGlobalsService(); }, token: BrowserGlobalsService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BrowserGlobalsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { BrowserGlobalsService };

//# sourceMappingURL=browser-globals.js.map